import script from "./Sprachtechnik-Platform.vue?vue&type=script&setup=true&lang=js"
export * from "./Sprachtechnik-Platform.vue?vue&type=script&setup=true&lang=js"

import "./Sprachtechnik-Platform.vue?vue&type=style&index=0&id=528b78c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-528b78c6"]])

export default __exports__